// extracted by mini-css-extract-plugin
module.exports = {"errorWrapper":"MediaPlayer_errorWrapper__1SIXq","player-container":"MediaPlayer_player-container__2yYx7"};